import { createOpenStore } from "stores/createOpenStore";
import type { OverlayInitialView } from "@/components/canvas/detailsSide/tableDetails/ColumnList/entities";

export interface ColumnPropertiesOpen {
  tableId: string;
  /** The view's own facts (filtered columns) when opened from one. */
  viewId?: string;
  columnId: string;
  view: OverlayInitialView;
  /** Above a bar slot; beside the details pane without one. */
  anchor?: HTMLElement;
}

export const useColumnPropertiesStore = createOpenStore<ColumnPropertiesOpen>();

export const openColumnProperties = (open: ColumnPropertiesOpen): void =>
  useColumnPropertiesStore.getState().show(open);
